// import { ReactRenderer } from '@tiptap/react';
// import tippy, { Instance as TippyInstance } from 'tippy.js';
// import MentionList from './MentionList';
// import { ProjectUser } from 'types/project';

// // This dynamic configuration receives the project users as a getter function
// export default function getSuggestionConfig(getUsers: () => ProjectUser[]) {
//   return {
//     items: ({ query }: { query: string }) => {
//       const usersList = getUsers();

//       return usersList
//         .filter((user) => {
//             const name = `${user.firstName} ${user.lastName}`.toLowerCase();
//             return name.includes(query.toLowerCase()) || (user.email && user.email.toLowerCase().includes(query.toLowerCase()));
//         })
//         .map((user) => ({
//             id: user.appUserUuid,
//             label: `${user.firstName} ${user.lastName}`,
//             email: user.email,
//             avatar: user.avatar
//         }))
//         .slice(0, 5); // display top 5 results
//     },

//     render: () => {
//       let component: ReactRenderer;
//       let popup: TippyInstance[];

//       return {
//         onStart: (props: any) => {
//           component = new ReactRenderer(MentionList, {
//             props,
//             editor: props.editor,
//           });

//           if (!props.clientRect) {
//             return;
//           }

//           popup = tippy('body', {
//             getReferenceClientRect: props.clientRect,
//             appendTo: () => document.body,
//             content: component.element,
//             showOnCreate: true,
//             interactive: true,
//             trigger: 'manual',
//             placement: 'bottom-start',
//           });
//         },

//         onUpdate(props: any) {
//           component.updateProps(props);

//           if (!props.clientRect) {
//             return;
//           }

//           popup[0].setProps({
//             getReferenceClientRect: props.clientRect,
//           });
//         },

//         onKeyDown(props: any) {
//           if (props.event.key === 'Escape') {
//             popup[0].hide();
//             return true;
//           }

//           return (component.ref as any)?.onKeyDown(props);
//         },

//         onExit() {
//           popup[0].destroy();
//           component.destroy();
//         },
//       };
//     },
//   };
// }

import { ReactRenderer } from '@tiptap/react';
import tippy, { Instance as TippyInstance } from 'tippy.js';
import MentionList from './MentionList';
import { ProjectUser } from 'types/project';
import { ContactOwner } from 'types/crm/contacts';

type MentionUser = ProjectUser | ContactOwner;

// Small helpers so we don't repeat the fallback logic in both filter() and map()
const getName = (user: MentionUser): string => {
  if ('name' in user) return user.name;                          // ContactOwner
  return `${user.firstName} ${user.lastName}`.trim();             // ProjectUser
};

const getId = (user: MentionUser): string => {
  return 'uuid' in user ? user.uuid : user.appUserUuid;
};

const getAvatar = (user: MentionUser): string | undefined => {
  return 'profileImageURL' in user && user.profileImageURL
    ? user.profileImageURL
    : (user as ProjectUser).avatar;
};

// This dynamic configuration receives the project users OR contact owners as a getter function
export default function getSuggestionConfig(getUsers: () => MentionUser[]) {
  return {
    items: ({ query }: { query: string }) => {
      const usersList = getUsers();

      return usersList
        .filter((user) => {
          const name = getName(user).toLowerCase();
          return name.includes(query.toLowerCase()) || (user.email && user.email.toLowerCase().includes(query.toLowerCase()));
        })
        .map((user) => ({
          id: getId(user),
          label: getName(user),
          email: user.email,
          avatar: getAvatar(user),
        }))
        .slice(0, 5); // display top 5 results
    },

    render: () => {
      let component: ReactRenderer;
      let popup: TippyInstance[];

      return {
        onStart: (props: any) => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
          });
        },

        onUpdate(props: any) {
          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props: any) {
          if (props.event.key === 'Escape') {
            popup[0].hide();
            return true;
          }

          return (component.ref as any)?.onKeyDown(props);
        },

        onExit() {
          popup[0].destroy();
          component.destroy();
        },
      };
    },
  };
}